import { AppError } from "../../app-store-error.types";

// **************************************************************************
// AUTHENTICATION STATE
// **************************************************************************
export interface AuthenticationState {
    isAuthenticated: boolean;
    error: AppError | null;
    loading: boolean;
}

export const initialAuthenticationState: AuthenticationState = {
    isAuthenticated: false,
    error: null,
    loading: true,
};
